import { StyledContent } from './ContentDisplay.styles';

interface Props {
    content: string;
    compact?: boolean;
}

const ContentDisplay = ({ content, compact = false }: Props) => {
    return (
        <StyledContent
            compact={compact}
            dangerouslySetInnerHTML={{ __html: content }}
        />
    );
};

export default ContentDisplay;
